<template>
    <main id="login" class="h-100">
        <div class="container-fluid h-100">
            <b-row class="h-100">
                <b-col id="bg-side" md="12">
                    <div id="logo" class="position-relative" />
                    <b-form
                        class="d-flex login-form flex-column justify-content-center w-50 mx-auto"
                        @submit.prevent="doResetPassword"
                    >
                        <b-form-group id="passowrd-input-group" :label="$t('message.password')" label-for="password">
                            <b-form-input
                                id="password"
                                v-model="loginForm.password"
                                v-validate="'required|min:6'"
                                :placeholder="$t('message.password')"
                                autocomplete="off"
                                class="mail"
                                ersUs
                                name="password"
                                type="password"
                            />
                            <span v-if="isSubmit" class="text-danger mt-3">{{ errors.first("password") }}</span>
                        </b-form-group>
                        <b-form-group
                            id="re-password-input-group"
                            :label="$t('message.passwordRepeat')"
                            label-for="password-repeat"
                        >
                            <b-form-input
                                id="password-repeat"
                                v-model="loginForm.repassword"
                                v-validate="'required|min:6'"
                                :placeholder="$t('message.passwordRepeat')"
                                autocomplete="off"
                                class="mail"
                                data-vv-as="password"
                                name="password-repeat"
                                type="password"
                            />
                            <span v-if="isSubmit" class="text-danger mt-3">{{ errors.first("password-repeat") }}</span>
                        </b-form-group>

                        <b-link class="text-center text-white" @click="() => $router.push('login')">
                            {{ $t("message.login") }}
                        </b-link>

                        <b-button :disabled="loading" class="mt-4 login-btn" type="submit" variant="primary">
                            <span v-if="loading">
                                <b-spinner small type="grow" />
                            </span>
                            <span v-else>
                                {{ $t("message.resetPassword") }}
                            </span>
                        </b-button>
                    </b-form>
                </b-col>
            </b-row>
        </div>
    </main>
</template>

<script>
import { mapActions } from "vuex";
import PasswordForgot from "../../components/svg/PasswordForgot";

export default {
    name: "ForgotPassword",
    components: { PasswordForgot },
    component: {
        PasswordForgot,
    },
    data() {
        return {
            loading: false,
            isSubmit: false,
            loginForm: {
                password: "",
                repassword: "",
                token: this.$route.query.token,
            },
        };
    },
    created() {},
    methods: {
        ...mapActions({
            resetPassword: "auth/resetPassword",
        }),
        doResetPassword() {
            this.isSubmit = true;
            this.$validator.validateAll().then((response) => {
                if (this.loginForm.password !== this.loginForm.repassword) {
                    this.$bvToast.toast("Two password must be same", {
                        title: "Error",
                        variant: "danger",
                        solid: true,
                    });
                } else {
                    if (response) {
                        this.loading = true;
                        this.resetPassword(this.loginForm)
                            .then((z) => {
                                this.$bvToast.toast(
                                    "Your password successfuly resetted , please login with new password",
                                    {
                                        title: "Successful",
                                        variant: "success",
                                        solid: true,
                                    }
                                );
                            })
                            .catch((error) => {
                                console.error("error --> ", error);
                                this.$bvToast.toast(error.response.data, {
                                    title: error.response.statusText || "Error",
                                    variant: "danger",
                                    solid: true,
                                });
                            })
                            .finally(() => (this.loading = false));
                    }
                }
            });
        },
    },
};
</script>
